import type { SegmentTreeNode } from '../../../../../../../../../modules/audiences/AudienceForm/types';

export const buildAllSegmentsMap = (allSegments: SegmentTreeNode[]): Map<string, SegmentTreeNode> => {
  const allSegmentsById = new Map<string, SegmentTreeNode>();

  allSegments.forEach(node => {
    allSegmentsById.set(node.id, node);
  });

  return allSegmentsById;
};
